import { UIView, UIViewAddSpec, UIViewSpec } from './view';
import { UIClassesSpec, UIRelPos } from './types';
import { YLocationParams, YNavigationResult, $location } from '../y/location';
import { $composer } from './composer';
import { $el } from './elements';

export interface UIScreenOptions {
    classes?: UIClassesSpec;
    footer?: UIViewAddSpec;
    menu?: UIViewAddSpec;
    no_crumbs?: boolean;
}

// TODOURGENT: @$y.LifetimeTracked
export abstract class UIScreen extends UIView {
    private _materialized: boolean = false;
    private _content!: HTMLElement;
    private _footer?: UIViewAddSpec;
    private _menu?: UIViewAddSpec;
    private _no_crumbs: boolean;
    private _title?: string;
    private _titlebar_color?: string;
    private _doc_title?: string;

    constructor(options: UIScreenOptions = {}) {
        super('article', ['ui-screen x-context', options.classes]);

        this._content = $el.DIV('ui-content');
        this._footer = options.footer;
        this._menu = options.menu;
        this._no_crumbs = !!options.no_crumbs;
    }

    protected abstract fillContent(content: UIViewSpec): void | Promise<void>;

    materialize() {
        if(this._materialized) return;

        this._materialized = true;

        const promise = this.fillContent(this._content);

        if(promise instanceof Promise) {
            promise.then(() => {
                this.ui_add([this._menu, this._content, this._footer]);
            });
        } else {
            this.ui_add([this._menu, this._content, this._footer]);
        }

        return promise;
    }

    addSidebar(position: UIRelPos, width: number, classes?: UIClassesSpec) {
        let pos_class: string;

        if(position == UIRelPos.Left) {
            this.root.style.setProperty('--ui-sidebar-l', `${width}px`)
            pos_class = 'a-left';
        } else {
            this.root.style.setProperty('--ui-sidebar-r', `${width}px`)
            pos_class = 'a-right';
        }

        const sidebar = $el.DIV(['ui-sidebar', pos_class, classes]);
        this.ui_add(sidebar);
        return sidebar;
    }

    replaceContent(content: UIViewSpec) {
        content.classList.add('ui-content');
        this._content.ui_replace(content);
        this._content = content.ui_elem;
    }

    onViewDidReappear?(): void;
    onViewWillDisappear?(new_path?: string[]): YNavigationResult;
    onViewDidDisappear?(): boolean | undefined | void;
    onSaveNavigationState?(): any;
    onWillUnload?(): string | undefined | void;
    onWillTransitionTo?(screen: UIScreen, params: YLocationParams): YLocationParams | undefined | void;
    onWillTransitionFrom?(screen: UIScreen, params: YLocationParams): YLocationParams | undefined | void;

    set titlebar_color(color: string | undefined) {
        this._titlebar_color = color;
        if($composer.isCurrentScreen(this))
            $composer.updateTitlebarColor();
    }

    get titlebar_color(): string | undefined {
        return this._titlebar_color;
    }

    set title(title: string | undefined) {
        this._title = title;
        if(!this._doc_title && $composer.isCurrentScreen(this))
            $composer.updateTitle();
    }

    get no_crumbs(): boolean {
        return this._no_crumbs;
    }

    get title(): string | undefined {
        return this._title;
    }

    set doc_title(title: string | undefined) {
        this._doc_title = title;
        $composer.updateTitle();
    }

    get doc_title(): string {
        if(this._doc_title)
            return this._doc_title;
        else if(this._title) {
            if($location.title_suffix)
                return this._title + ' | ' + $location.title_suffix;
            else
                return this._title;
        } else {
            return '';
            // return $location.title_suffix;
        }
    }

    set footer(footer: UIViewAddSpec | undefined) {
        this._footer = footer;
    }
}
